import React, { useState, useEffect } from 'react';
import { Modal, Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import CompanyRegister from '../auth/CompanyRegister';
import companyApi from '../../api/companyApi';

const EditProfile = ({ visible, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(true);
  const [companyData, setCompanyData] = useState(null);

  useEffect(() => {
    if (visible) {
      fetchCompanyData();
    }
  }, [visible]);

  const fetchCompanyData = async () => {
    try {
      setLoading(true);
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      
      if (userInfo.company) {
        const data = await companyApi.getCompanyProfile(userInfo.company);
        setCompanyData(data);
      } else {
        message.error('No company ID found. Please login again.');
      }
    } catch (error) {
      message.error('Failed to load company data');
      console.error('Error fetching company data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    message.success('Profile updated successfully!');
    if (onSuccess) onSuccess();
    onClose();
  };

  return (
    <Modal
      title="Edit Profile"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1100}
      centered
      destroyOnClose
      bodyStyle={{ 
        maxHeight: '80vh', 
        overflowY: 'auto',
        padding: '24px'
      }}
    >
      {loading ? (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '200px' 
        }}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: '#3C007A' }} spin />} />
        </div>
      ) : (
        <CompanyRegister 
          editingCompany={companyData} 
          onSuccess={handleSuccess}
        />
      )}
    </Modal>
  );
};

export default EditProfile;
